// QAPAQ SpA — Página pública de contenido (Fase 3 SEO)
//
// Dibuja /transportistas, /empresas y /como-funciona a partir de
// src/content/paginasPublicas.js, con el mismo encabezado y pie de la landing.
// Se prerenderiza en el build: no debe tocar window/document al renderizar.

import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Navbar, CtaFinal, Footer } from './LandingPage'
import { PAGINAS } from '../content/paginasPublicas'
import '../styles/landing.css'

export default function PaginaInfo({ slug }) {
  const p = PAGINAS[slug]

  // El HTML prerenderizado ya trae su título; esto lo mantiene correcto al
  // llegar navegando dentro de la app.
  useEffect(() => { document.title = p.titulo }, [p.titulo])

  // Se llega a estas páginas desde enlaces del pie: sin esto se abrirían
  // con el scroll de la página anterior.
  useEffect(() => { window.scrollTo(0, 0) }, [slug])

  return (
    <div className="landing">
      <Navbar />

      <header className="pg-hero">
        <div className="ln-container">
          <span className="ln-section-label">{p.kicker}</span>
          <h1 className="pg-hero__title">{p.h1}</h1>
          <p className="pg-hero__intro">{p.intro}</p>
          <Link to={p.cta.ruta} className="ln-btn ln-btn--primary ln-btn--lg">{p.cta.texto}</Link>
        </div>
      </header>

      {p.pasos && (
        <section className="ln-section">
          <div className="ln-container">
            <ol className="pg-pasos">
              {p.pasos.map((paso, i) => (
                <li key={paso.titulo} className="pg-paso">
                  <span className="pg-paso__num">{String(i + 1).padStart(2, '0')}</span>
                  <h2 className="pg-paso__titulo">{paso.titulo}</h2>
                  <p>{paso.texto}</p>
                </li>
              ))}
            </ol>
          </div>
        </section>
      )}

      {p.secciones && (
        <section className="ln-section">
          <div className="ln-container pg-secciones">
            {p.secciones.map(s => (
              <article key={s.titulo} className="pg-seccion">
                <h2 className="pg-seccion__titulo">{s.titulo}</h2>
                {s.parrafos?.map(t => <p key={t}>{t}</p>)}
                {s.items && <ul className="pg-lista">{s.items.map(t => <li key={t}>{t}</li>)}</ul>}
                {s.nota && <p className="pg-nota">{s.nota}</p>}
              </article>
            ))}
          </div>
        </section>
      )}

      {p.faq && (
        <section className="ln-section pg-faq-wrap" id="preguntas">
          <div className="ln-container">
            <div className="ln-section-label">Preguntas frecuentes</div>
            <h2 className="ln-section-title">Lo que más nos preguntan</h2>
            <div className="pg-faq">
              {p.faq.map(f => (
                <details key={f.p} className="pg-faq__item">
                  <summary>{f.p}</summary>
                  <p>{f.r}</p>
                </details>
              ))}
            </div>
            <p className="pg-nota">
              ¿Otra duda? Escríbenos a <a href="mailto:contacto@qapaq.cl">contacto@qapaq.cl</a> o revisa
              los <Link to="/app/terminos">Términos y Condiciones</Link>.
            </p>
          </div>
        </section>
      )}

      <CtaFinal />
      <Footer />
    </div>
  )
}
